import Grid from "@mui/material/Grid";
import { CajasProvider } from "../../../context/CajasContext/CajasContext";
import { ConsultaComprobantesList } from "../components/ConsultaComprobantesList";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export function ConsultaComprobantes() {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Consulta de Comprobantes" icon={<ReceiptLongIcon />} />
      <CajasProvider>
        <ConsultaComprobantesList />
      </CajasProvider>
    </Grid>
  );
}
